export const TAGS = {
	outlet: "Outlet",
	sale: "Outlet",
	new: "Nyhet",
	comingSoon: "Kommer snart",
	free: "Gratis",
	archive: "Arkiv",
};
